import { cx } from '@libs/classnames';
import { FancyBadge } from '@ui/components/FancyBadge';
import { MicIcon } from '@ui/icons/MicIcon';

import { MediaDevices } from '@features/video/hooks/useMediaDevices';
import { MediaDeviceSettings } from '@features/video/ui/MediaDeviceSettings';
import { StreamControls } from '@features/video/ui/StreamControls';

import styles from './RefereeJoin.module.css';

export type Props = {
  className?: string;
  title: string;
  devices: MediaDevices;
  // нет доступа к микрофону, нет связи с сервером
  error?: string | null;
  isJoining?: boolean;
  // войти сразу с выключенным микрофоном: та же кнопка, что в шапке после входа
  micOn: boolean;
  onToggleMic: () => void;
  onJoin: () => void;
};

// Первый экран судьи: выбор микрофона и вход в комнату. Браузер запросит доступ,
// поэтому настройки показываем до подключения, а не прячем в меню
export function RefereeJoin({
  className,
  title,
  devices,
  error,
  isJoining,
  micOn,
  onToggleMic,
  onJoin,
}: Props) {
  const isReady = devices.status === 'ready';

  return (
    <div className={cx(styles.join, className)}>
      <div className={styles.join__icon}>
        <MicIcon />
      </div>
      <h2 className={styles.join__title}>{title}</h2>
      <p className={styles.join__text}>Игроки услышат вас через микрофон.</p>

      <MediaDeviceSettings className={styles.join__settings} audio devices={devices} />

      <StreamControls micOn={micOn} onToggleMic={onToggleMic} />

      {error && <p className={styles.join__error}>{error}</p>}

      <FancyBadge className={styles.join__button} disabled={!isReady || isJoining} onClick={onJoin}>
        {isJoining ? 'Подключение...' : 'Подключиться'}
      </FancyBadge>
    </div>
  );
}
